import { AxiosInstance } from 'axios';
import * as t from 'io-ts';
import { decodeP } from './helpers/decode';
import { ApiProps, UserId, PartialNullable } from './types';
import { UnexpectedError } from './errors/UnexpectedError';
import { isBadRequestHttpError } from '../utils/httpErrors';
import { BadRequestError } from './errors/BadRequestError';

const eventDecoder = t.type({
  eventId: t.string,
  hostUrl: t.string,
  guestUrl: t.string,
});

const hostAccessTokenDecoder = t.type({
  accessToken: t.string,
});

type CreateEventProps = PartialNullable<ApiProps & UserId> & {
  title: string;
  destinations: { rtmpUrl: string; streamKey: string }[];
};

export const events = (apiClient: AxiosInstance) => ({
  create: async ({
    clientId,
    clientSecret,
    userId,
    title,
    destinations,
  }: CreateEventProps) => {
    try {
      const { data } = await apiClient.post(
        `/v2/studio-integrations/users/${userId}/events`,
        {
          clientId,
          clientSecret,
          title,
          destinations,
        },
      );

      return await decodeP(eventDecoder, data);
    } catch (e) {
      if (isBadRequestHttpError(e)) {
        throw new BadRequestError();
      }

      throw new UnexpectedError();
    }
  },
  getHostAccessToken: async ({
    clientId,
    clientSecret,
    userId,
  }: PartialNullable<ApiProps & UserId>) => {
    const {
      data,
    } = await apiClient.post(
      `/v2/studio-integrations/users/${userId}/access-tokens`,
      { clientId, clientSecret },
    );

    return await decodeP(hostAccessTokenDecoder, data);
  },
});
